import { render, staticRenderFns } from "./ChapterPractice.vue?vue&type=template&id=6f9aa1e2&scoped=true&"
import script from "./ChapterPractice.vue?vue&type=script&lang=js&"
export * from "./ChapterPractice.vue?vue&type=script&lang=js&"
import style0 from "./ChapterPractice.vue?vue&type=style&index=0&id=6f9aa1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9aa1e2",
  null
  
)

export default component.exports